





















import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import Pill from "@/shared/components/ui/Pill.vue";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap
} from "@/shared/types";
import { v4 as uuid } from "uuid";

@Component({
  components: {
    Pill
  }
})
export default class HsabExpenseReimbursementStatusPill extends Vue {

  @Prop({ required: true })
  status: CombinedClaimReceiptStatus;

  showTooltip = false;

  get showStatusPill () {
    return this.status !== CombinedClaimReceiptStatus.None;
  }

  get pillType () {
    switch (this.status) {
      case CombinedClaimReceiptStatus.Paid:
      case CombinedClaimReceiptStatus.MarkedAsPaid:
      case CombinedClaimReceiptStatus.PartiallyPaid:
        return "green-bg";
      case CombinedClaimReceiptStatus.ReceiptNeeded:
      case CombinedClaimReceiptStatus.NewReceiptNeeded:
      case CombinedClaimReceiptStatus.ReceiptOverdue:
        return "red-bg";
    }
    return "grey-bg";
  }

  get displayText () {
    return CombinedClaimReceiptStatusMap[this.status];
  }

  get displayHelpText (): { text: string; id: string } {

    switch (this.status) {
      case CombinedClaimReceiptStatus.Paid:
        return {
          text: "The expense was paid. There's no action you need to take.",
          id: "tooltip-paid" + uuid(),
        };
      case CombinedClaimReceiptStatus.PartiallyPaid:
        return {
          text: "The expense was partially paid. There's no action you need to take.",
          id: "tooltip-partiallyPaid" + uuid(),
        };
      case CombinedClaimReceiptStatus.ReceiptNeeded:
        return {
          text: "Expense submitted but a receipt is required for payment. Please upload the appropriate receipt for this expense.",
          id: "tooltip-receiptNeeded" + uuid(),
        };
      case CombinedClaimReceiptStatus.Locked:
        return {
          text: "This expense status is updating and no action can be taken at this time.",
          id: "tooltip-locked" + uuid(),
        };
      case CombinedClaimReceiptStatus.Hold:
        return {
          text: "This expense has a hold and no action can be taken at this time.",
          id: "tooltip-hold" + uuid(),
        };
      case CombinedClaimReceiptStatus.Pending:
        return {
          text: "This expense was submitted and is pending. There's no action you need to take.",
          id: "tooltip-pending" + uuid(),
        };
      case CombinedClaimReceiptStatus.Repaid:
        return {
          text: "This initially denied expense was repaid and is no longer due. There's no action you need to take.",
          id: "tooltip-repaid" + uuid(),
        };
      case CombinedClaimReceiptStatus.RepaymentDue:
        return {
          text: "This expense was paid, but later denied. You are required to repay the denied amount.",
          id: "tooltip-repaymentDue" + uuid(),
        };
      case CombinedClaimReceiptStatus.Expired:
        return {
          text: "This expense wasn't submitted before the final filing date. There's no action you can take at this time.",
          id: "tooltip-expired" + uuid(),
        };
      case CombinedClaimReceiptStatus.ReceiptOverdue:
        return {
          text: "Expense submitted but a receipt is required for payment. Please upload the appropriate receipt for this expense.",
          id: "tooltip-receiptOverdue" + uuid(),
        };
      case CombinedClaimReceiptStatus.NewReceiptNeeded:
        return {
          text: "Expense submitted but a receipt is required for payment. Please upload the appropriate receipt for this expense.",
          id: "tooltip-newReceiptNeeded" + uuid(),
        };
      case CombinedClaimReceiptStatus.Denied:
        return {
          text: "This expense doesn't qualify as an eligible expense.",
          id: "tooltip-denied" + uuid(),
        };
      case CombinedClaimReceiptStatus.Submitted:
        return {
          text: "This expense is pending. There's no action for you to take at this time.",
          id: "tooltip-submitted" + uuid(),
        };
      case CombinedClaimReceiptStatus.Resubmitted:
        return {
          text: "This resubmitted expense is pending. There's no action for you to take at this time.",
          id: "tooltip-resubmitted" + uuid(),
        };
      case CombinedClaimReceiptStatus.Applied:
        return {
          text: "This claim was submitted but isn't eligible for payment until you meet the deductible.",
          id: "tooltip-applied" + uuid(),
        };
      case CombinedClaimReceiptStatus.PendingReceipt:
        return {
          text: "This expense was submitted but requires the appropriate receipt.",
          id: "tooltip-pendingReceipt" + uuid(),
        };
      case CombinedClaimReceiptStatus.PendingReimbursement:
        return {
          text: "This expense was approved and is pending payment. There's no action for you to take.",
          id: "tooltip-pendingReimbursement" + uuid(),
        };
      case CombinedClaimReceiptStatus.ScheduledReimbursement:
        return {
          text: "This expense was approved and payment is scheduled but not yet posted. There's no action for you to take.",
          id: "tooltip-scheduledReimbursement" + uuid(),
        };
      case CombinedClaimReceiptStatus.Unsubmitted:
        return {
          text: "This expense/claim wasn't submitted for reimbursement.",
          id: "tooltip-unsubmitted" + uuid(),
        };
      case CombinedClaimReceiptStatus.MarkedAsPaid:
        return {
          text: "This expense was paid.",
          id: "tooltip-markedAsPaid" + uuid(),
        };
      case CombinedClaimReceiptStatus.Available:
        return {
          text: "This claim is not linked to an expense.",
          id: "tooltip-available" + uuid(),
        };
      default:
        return {
          text: "Claim status",
          id: "tooltip-default" + uuid(),
        };
    }
  }

  toggleTooltip () {
    this.showTooltip = !this.showTooltip; // Toggle tooltip visibility on click
  }

}
